import React from 'react';
import { MatterDetailed } from '../../../types/matters';
import MatterCard from './MatterCard';

interface MattersCardViewProps {
  matters: MatterDetailed[];
  loading: boolean;
  onMatterClick: (matter: MatterDetailed) => void;
  searchQuery?: string; // Add searchQuery prop
}

const MattersCardView: React.FC<MattersCardViewProps> = ({
  matters,
  loading,
  onMatterClick,
  searchQuery = ''
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600 dark:text-gray-400">Loading engagements...</span>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {matters.length === 0 ? (
        <div className="col-span-full text-center py-12">
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-8">
            <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
              No engagements found
            </h3>
            <p className="text-gray-500 dark:text-gray-400">
              Get started by creating your first engagement.
            </p>
          </div>
        </div>
      ) : (
        matters.map((matter) => (
          <div key={matter.id} className="w-full">
            <MatterCard
              matter={matter}
              onClick={() => onMatterClick(matter)}
              searchQuery={searchQuery}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default MattersCardView;
